import { styled } from '@mui/material'

export const StyledCenteredContent = styled('div')({
   display: 'flex',
   justifyContent: 'center',
   alignItems: 'center',
})

export const ButtonContainer = styled('div')({
   display: 'flex',
   gap: 12,
   justifyContent: 'center',
})

export const StyledTableWrapper = styled('div')({
   '.MuiTableCell-root': {
      padding: '6px 8px 6px 8px',
      textAlign: 'center',
   },
   '.MuiTableCell-head': {
      backgroundColor: 'rgba(33,147,224, 0.1)',
      color: 'grayText',
   },
})
